<template>
  <div id="getStarted">
    <main class="get-started-main">
      <div class="row">
        <div class="col-6 center">
          <img class="alternative_flow_island_left" src="static/images/alternative_flow/alternative_island_l.svg" />
        </div>
        <div class="col-6 center">
          <img class="alternative_flow_island_right" src="static/images/alternative_flow/alternative_island_r.svg" />
        </div>
        <div class="col-12 center">
          <img v-if="gameType === 'ODD'" class="alternative_flow_game_odd" src="static/images/alternative_flow/alternative_game_odd.png" />
        </div>
      </div>
    </main>
    <main class="get-started-alternative-flow-inner-modal">
      <div class="row alternative-flow-gamepage_header">
        <img class="gamepage_logo" src="static/images/logo-odd-object.png">
        <h1 v-if="gameType === 'ODD'">{{ getTranslations.home_game_odd_game }}</h1>
        <p class="alternative-flow-main-lead">{{ getTranslations.visitor_alternative_simply_play }}</p>
        <p>{{ getTranslations.visitor_alternative_and_discover_your }}</p>
      </div>
      <div class="row center getstarted-ctas">
        <div class="col-md-12">
          <a class="ti_btn--green" @click.prevent="playFreeGame()">{{ getTranslations.visitor_alternative_play }}</a>
        </div>
      </div>
    </main>
  </div>
</template>

<script>
/* eslint no-console: "off" */
import { mapState, mapActions, mapGetters } from 'vuex';

export default {
  name: 'game-index',
  created() {
    console.log('in Free GameIntro created hook:');
  },
  methods: {
    ...mapActions('game', [
      'checkIfGameToResumeExistsForUnauthorizedUsers',
    ]),
    playFreeGame() {
      this.checkIfGameToResumeExistsForUnauthorizedUsers().then((res) => {
        if (res.data.responseEnum === 'NO_GAME_EXISTS') {
          this.$router.push(`searchingOpponentForPrize/${this.gameType}`);
        } else {
          this.$router.push('/');
        }
      }).catch(error => console.error(error));
    },
  },
  computed: {
    ...mapState('common', [
      'unauthorizedMsisdn',
      'validTransitionForFreeGame',
    ]),
    ...mapState('game', [
      'gameType',
    ]),
    ...mapGetters('i18n', [
      'getTranslations',
    ]),
  },
};
</script>



// WEBPACK FOOTER //
// src/components/visitor/freeGameProcess/FreeGameIndexProcess.vue